import { BRAND, APP_TYPES } from '@config';
import { setBeamRotation, setBeamRotateDirection, setBeamState } from '@reducers/options/beam/actions';
import { setCladdingType } from '@reducers/options/cladding/actions';
import { setDy, setPanelState } from '@reducers/options/panel/actions';
import { setScrewOptions, setScrewState } from '@reducers/options/screw/actions';
import { getSBPredefinedBP, getSBPredefinedBPImage } from '@reducers/web-services/application/actions';
import { mergeDeep } from '@services/helper.service';
import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { setBasePlateOptions } from '../dimension/actions';
import { standardList } from '@src/app.values';
import { defaultProfileState, defaultMaterialState } from '@reducers/web-services/profile/index';
import { getProfileShape, getProfileSizes } from '@reducers/web-services/profile/actions';
import { setRebarDesign } from '../design/actions';
import { REBAR } from '../design/types';

export const SET_SQUARE_ACTIVE_BTN = 'SET_SQUARE_ACTIVE_BTN';
export const SET_CIRCLE_ACTIVE_BTN = 'SET_CIRCLE_ACTIVE_BTN';
export const SET_TRIANGLE_ACTIVE_BTN = 'SET_TRIANGLE_ACTIVE_BTN';
export const SET_EDITOR_ACTIVE_BTN = 'SET_CUSTOM_EDITOR_ACTIVE_BTN';

export const SET_STAND_OFF_ACTIVE_BTN = 'SET_STAND_OFF_ACTIVE_BTN';

export const SET_PROFILE_MATERIAL = 'SET_GENERAL_CALCULATION_PROFILE_MATERIAL';
export const SET_PROFILE_FAMILY = 'SET_GENERAL_CALCULATION_PROFILE_FAMILY';
export const SET_PROFILE_SIZE = 'SET_GENERAL_CALCULATION_PROFILE_SIZE';
export const SET_PROFILE_ROTATION = 'SET_PROFILE_ROTATION';
export const SET_PROFILE_ROTATE_DIRECTION = 'SET_PROFILE_ROTATE_DIRECTION';

export const SET_SAFETY_BARRIER_ACTIVE_TYPE = 'SET_SAFETY_BARRIER_ACTIVE_TYPE';
export const SET_SAFETY_BARRIER_ACTIVE_SUBTYPE = 'SET_SAFETY_BARRIER_ACTIVE_SUBTYPE';
export const SET_SAFETY_BARRIER_ACTIVE_PLATE = 'SET_SAFETY_BARRIER_ACTIVE_PLATE';

export const SET_CLADDING = 'SET_CLADDING';

export const SET_BRACKET_ATTACHMENT_ACTIVE_BTN = 'SET_BRACKET_ATTACHMENT_ACTIVE_BTN';

export const SET_REBAR_REINFORCEMENT_ACTIVE_BTN = 'SET_REBAR_REINFORCEMENT_ACTIVE_BTN';

export const RESET_PROFILES = 'RESET_PROFILES';
export const RESET_APPLICATION_STATE = 'RESET_APPLICATION_STATE';
export const SET_APPLICATION_STATE = 'SET_APPLICATION_STATE';
export const SET_MANUFACTURER = 'SET_MANUFACTURER';
export const SET_DESIGNATION = 'SET_DESIGNATION';
export const SET_PREDEFINED_BASEPLATE = 'SET_PREDEFINED_BASEPLATE';
export const SET_PREDEFINED_BASEPLATE_IMAGE = 'SET_PREDEFINED_BASEPLATE_IMAGE';

export const SET_WOOD_PANEL_OPTIONS = 'SET_WOOD_CONNECTION_THICKNESS';
export const SET_WOOD_CONNECTION_TYPE = 'SET_WOOD_CONNECTION_TYPE';

/*
  Action creators
 */
export function setSquareActiveBtn(id) {
  return { type: SET_SQUARE_ACTIVE_BTN, id };
}
export function setCircleActiveBtn(id) {
  return { type: SET_CIRCLE_ACTIVE_BTN, id };
}
export function setTriangleActiveBtn(id) {
  return { type: SET_TRIANGLE_ACTIVE_BTN, id };
}
export function setEditorActiveBtn(isActive) {
  return { type: SET_EDITOR_ACTIVE_BTN, isActive };
}

export function setStandOffActiveBtn(id) {
  return { type: SET_STAND_OFF_ACTIVE_BTN, id };
}

export function setProfileMaterial(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_MATERIAL, value, appType: getState().main.appType });
  };
}
export function setProfileFamily(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_FAMILY, value, appType: getState().main.appType });
  };
}
export function setProfileSize(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_SIZE, value, appType: getState().main.appType });
  };
}
export function setProfileRotation(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_ROTATION, value, appType: getState().main.appType });
    dispatch(setBeamRotation(value));
  };
}
export function setProfileRotateDirection(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_ROTATE_DIRECTION, value, appType: getState().main.appType });
    dispatch(setBeamRotateDirection(value));
  };
}

export function setActiveType(id) {
  return { type: SET_SAFETY_BARRIER_ACTIVE_TYPE, id };
}
export function setActiveSubtype(id) {
  return { type: SET_SAFETY_BARRIER_ACTIVE_SUBTYPE, id };
}
export function setActivePlate(id) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SAFETY_BARRIER_ACTIVE_PLATE, id });
    let subType = getState().selectors.application[getState().main.appType].selectedSubtype;
    if (subType && subType.plate) {
      let plate = subType.plate.find(p => p.id === id);
      dispatch(setScrewOptions(mergeDeep({}, { padding: plate.config.screw.padding })));
      dispatch(setDy({
        isCustom: true,
        value: plate.config.screw.padding.dy
      }));
    }
  };
}

export function setCladding(value) {
  return (dispatch, getState) => {
    let appType = getState().main.appType;
    dispatch({ type: SET_CLADDING, value, appType });
    dispatch(setCladdingType(value));
  };
}

export function setBracketAttachmentActiveBtn (id) {
  return { type: SET_BRACKET_ATTACHMENT_ACTIVE_BTN, id };
}

export function setRebarReinforcementActiveBtn(id) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_REINFORCEMENT_ACTIVE_BTN, id });
    // beam to wall do not have EC2-FIRE
    if (id === '2' && getState().selectors.design[APP_TYPES.REBAR_REINFORCEMENT].design === REBAR.types.EUROCODE_2_FIRE) {
      dispatch(setRebarDesign(REBAR.types.EUROCODE_2));
    }
  };
}

export function resetProfiles() {
  return { type: RESET_PROFILES };
}

export function resetApplicationState(appType) {
  return (dispatch, getState) => {
    dispatch({ type: RESET_APPLICATION_STATE, appType: appType || getState().main.appType, country: getState().main.localization.country });
  };
}

export function setApplicationState(state) {
  return { type: SET_APPLICATION_STATE, state };
}

export function setManufacturer(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MANUFACTURER, appType: getState().main.appType, value });
    dispatch(setDesignation(''));
    dispatch(resetSBBasePlate());
  };
}
export function setDesignation(value) {
  return (dispatch, getState) => {
    if (!value) {
      dispatch({ type: SET_DESIGNATION, appType: getState().main.appType, id: '' });
    } else {
      const predefinedBasePlate = getState().selectors.application[getState().main.appType].predefinedBasePlate;
      if (predefinedBasePlate) {
        const manufacturer = predefinedBasePlate.selectedManufacturer;
        var designation = getState().webServices.application.designations[manufacturer].find(d => d.id === value).designation;
        if (designation) {
          dispatch({ type: SET_DESIGNATION, appType: getState().main.appType, id: value, designation });
          dispatch(getSBPredefinedBPImage());
          if (predefinedBasePlate.isPredefinedBasePlate) {
            dispatch(getSBPredefinedBP());
          }
        }
      }
    }
  };
}
export function setPredefinedBasePlate(value) {
  return (dispatch, getState) => {
    const appType = getState().main.appType;
    const predefinedBasePlate = getState().selectors.application[getState().main.appType].predefinedBasePlate;
    var prevValue, manufacturer, designation;
    if (predefinedBasePlate) {
      prevValue = predefinedBasePlate.isPredefinedBasePlate;
      manufacturer = predefinedBasePlate.selectedManufacturer;
      designation = predefinedBasePlate.selectedDesignationId;
    }
    dispatch({ type: SET_PREDEFINED_BASEPLATE, appType, value });
    if (value && manufacturer && designation) {
      dispatch(getSBPredefinedBP());
    } else if (prevValue) { // reset only when switching from true to false
      dispatch(resetSBBasePlate());
    }
  };
}
export function setPredefinedBasePlateImg(imagePath) {
  return (dispatch, getState) => {
    const appType = getState().main.appType;
    dispatch({ type: SET_PREDEFINED_BASEPLATE_IMAGE, appType, imagePath });
  };
}
export function resetSBBasePlate() {
  return (dispatch, getState) => {
    // reset to the specific defaults
    const appType = getState().main.appType;
    // const type = getState().selectors.application[appType].selectedType;
    // const subtype = getState().selectors.application[appType].selectedSubtype;
    const plate = getState().selectors.application[appType].selectedPlate;

    dispatch(setBasePlateOptions({
      lx: initDimensionState[appType].basePlate.lx,
      ly: initDimensionState[appType].basePlate.ly,
      // dpp: initDimensionState[appType].basePlate.dpp,
      // dpl: initDimensionState[appType].basePlate.dpl,
      lyh: initDimensionState[appType].basePlate.lyh,

      tfix: initDimensionState[appType].basePlate.tfix,

      spacing: {
        s1: plate.config.screw.padding.s1,
        s2: plate.config.screw.padding.s2,
        dy: plate.config.screw.padding.dy,
        d: plate.config.screw.padding.diameter,
      },

      // edgeDistance: {
      //   c1x: type.config.ground.padding.C1x || null,
      //   c2x: type.config.ground.padding.C2x || null,
      //   c1y: type.config.ground.padding.C1y || null,
      // }
    }));
    dispatch(setPanelState(mergeDeep({}, getState().options.panel, {
      width: initDimensionState[appType].basePlate.lx,
      height: initDimensionState[appType].basePlate.ly,
      dpp: {
        value: initDimensionState[appType].basePlate.dpp
      },
      dpl: {
        value: initDimensionState[appType].basePlate.dpl
      },
      lyh: {
        value: initDimensionState[appType].basePlate.lyh
      },
      depth: initDimensionState[appType].basePlate.tfix,
      dy: {
        value: plate.config.screw.padding.dy,
      },
    })));
    dispatch(setScrewState(mergeDeep({}, getState().options.screw, {
      padding: {
        s1: plate.config.screw.padding.s1,
        s2: plate.config.screw.padding.s2,
        diameter: plate.config.screw.padding.diameter
      },
    })));
    // dispatch(setGroundState(mergeDeep({}, getState().options.ground, {
    //   padding: {
    //     C1x: type.config.ground.padding.C1x || null, // Null = ∞ char in UI
    //     C2x: type.config.ground.padding.C2x || null,
    //     C1y: type.config.ground.padding.C1y || null,
    //   },
    // })));
    
    dispatch(setBeamState(mergeDeep({}, getState().options.beam, {
      shift: {
        x: initDimensionState[appType].axisPosition.ex,
        y: initDimensionState[appType].axisPosition.ey
      }
    })));
    
    let profileType = getState().main.localization.profileType;
    let profileNumber = Number(getState().main.localization.designStandard) === standardList["Masonry"] ? 3 : (profileType || 0);
    dispatch(setProfileMaterial(defaultMaterialState[BRAND][appType]));
    dispatch(setProfileFamily(defaultProfileState[appType][profileNumber].family));
    dispatch(getProfileSizes(defaultProfileState[appType][profileNumber].family,
      (profileSizes) => {
        if (profileSizes && profileSizes.length) {
          let size = profileSizes.find((size) => {
            return size.InternalName === defaultProfileState[appType][profileNumber].size;
          });
          if (size === null || size === undefined)
            size = profileSizes[0];
          dispatch(setProfileSize(size.InternalName));
          dispatch(getProfileShape(defaultProfileState[appType][profileNumber].family, size.InternalName, true));
        }
      })
    );
  };
}

export function setWoodPanelOptions(options) {
    return (dispatch) => {
        dispatch({ type: SET_WOOD_PANEL_OPTIONS, options });
    };
}

export function setWoodConnectionType(value) {
    return (dispatch) => {
        dispatch({ type: SET_WOOD_CONNECTION_TYPE, value });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/actions.js